export default {
    apiUrl: 'https://api.app.recruto.ca',
};